export const environment = {
  production: false,
  IsAppInReview: false,
  applicationVersion: "26.6.1",
  appName: 'St Mina Riverside',
  iTokenUrl: `https://isv.cardconnect.com/itoke/ajax-tokenizer.html?autofocus=true&cardlabel=CustomCard&tokenizewheninactive=true&inactivityto=10000
  &invalidcreditcardevent=true&cardinputmaxlength=16&cardnumbernumericonly=true&placeholder=Credit Card Number
  &css=.error%7Bcolor%3Ared%3Bborder-color%3Ared%3B%7D%23ccnumfield%7Bwidth%3A250px%3Bfont-size%3A1rem%21important%3Bheight%3A30px%3Bpadding%3A.5rem+0.5rem%3Bline-height%3A1.5%3Bborder-radius%3A.3rem%3Bdisplay%3Ablock%3Bfont-weight%3A400%3Bcolor%3A%23495057%3Bbackground-color%3A%23fff%3Bbackground-clip%3Apadding-box%3Bborder%3A1px+solid+%23ced4da%3Boverflow%3Avisible%3Bmargin%3A0%3Bfont-family%3A%22cabin%22%2C+sans-serif%3B-webkit-appearance%3Atextfield%3Bbox-sizing%3Aborder-box%3B%7D`
};

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
